import { render, staticRenderFns } from "./ShowsMessageBox.vue?vue&type=template&id=729f4a39&"
import script from "./ShowsMessageBox.vue?vue&type=script&lang=js&"
export * from "./ShowsMessageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports